module.exports = __webpack_public_path__ + "img/组 2941(1).745f93cc.svg";